/* eslint-disable @typescript-eslint/no-explicit-any */
import { requestGetReport01 } from 'app/api/report'
import { ReportMessageCode } from 'app/api/report/constant'
import {
  IParamsGetReport01,
  IResponseGetReport01,
} from 'app/api/report/model/report-01'
import { useBaseTableReportHook } from 'app/components/tables/BaseTableReport/hook'
import {
  IDataBaseTable,
  IParamsHookReport,
} from 'app/components/tables/BaseTableReport/type'
import { randomMoney } from 'app/components/tables/common-table/constant'
import { isEqual } from 'lodash'
import { Pagination } from 'parkway-web-common'
import {
  convertGeneralReport01Value,
  sumDataReport01,
  useCommonHook,
} from '../common-hook'
import { initialPagination } from '../common-model'
import { IDataReport01Monthly } from './data'

export const useTableMonthlyHook = (props: IParamsHookReport) => {
  const getDataMonthly = async (
    pagination: Pagination,
    params: IParamsHookReport,
  ) => {
    const initData = {
      pagination: pagination ?? initialPagination,
      data: [],
    } as IDataBaseTable<IDataReport01Monthly>
    try {
      const dataToSend: IParamsGetReport01 = {
        year: params?.year ?? props?.year,
        month: params?.month ?? props?.month,
      }
      const response: IResponseGetReport01 = await requestGetReport01(
        dataToSend,
      )

      if (
        isEqual(response?.msgcode, ReportMessageCode.Report01.successGetData)
      ) {
        const data = response?.data ?? []
        let dataTable: IDataReport01Monthly[] = []
        let dataTotalOfTable: IDataReport01Monthly = {}
        data.forEach((service, indexService) => {
          const [firstArea, ...otherArea] = service?.area ?? []
          const [firstClinicOfFirstArea, ...otherClinicOfFirstArea] =
            firstArea?.clinic ?? []

          const keyOfService = indexService + 1

          const keyOfFirstClinic = Number(`${keyOfService * 10}1`)
          const dataOfFirstArea = convertGeneralReport01Value(
            firstArea,
            'total',
          )
          const dataOfFirstClinic = convertGeneralReport01Value(
            firstClinicOfFirstArea,
            'normal',
          )

          const saveData = {
            key: keyOfService,
            service: service?.serviceName,
            isNotExpanded: true,

            area: firstArea?.areaName,
            childrenKey: keyOfFirstClinic,
            clinic: firstClinicOfFirstArea?.clinicName,

            ...dataOfFirstArea,
            ...dataOfFirstClinic,
            childOfFirstChild: otherClinicOfFirstArea?.map(
              (clinic, indexClinic) => {
                const dataOfClinic = convertGeneralReport01Value(
                  clinic,
                  'normal',
                )
                const keyChild = Number(`${keyOfFirstClinic}${indexClinic}`)
                return {
                  key: keyChild,
                  clinic: clinic.clinicName,
                  parentKey: keyOfFirstClinic,
                  index: indexClinic + 1,
                  ...dataOfClinic,
                }
              },
            ),
            children: otherArea?.map((otherArea, indexOtherArea) => {
              const [firstClinicOfArea, ...otherClinicOfOtherArea] =
                otherArea?.clinic ?? []
              const dataOfOtherArea = convertGeneralReport01Value(
                otherArea,
                'total',
              )
              const dataOfFirstClinicOfOtherArea = convertGeneralReport01Value(
                firstClinicOfArea,
                'normal',
              )

              const keyOfClinic = Number(
                `${(indexService + 1) * 10}${indexOtherArea + 2}`,
              )

              return {
                key: keyOfClinic,
                area: otherArea?.areaName,
                clinic: firstClinicOfArea?.clinicName,

                ...dataOfOtherArea,
                ...dataOfFirstClinicOfOtherArea,

                children: otherClinicOfOtherArea?.map((clinic, idxChild) => {
                  const dataOfClinic = convertGeneralReport01Value(
                    clinic,
                    'normal',
                  )
                  const keyChild = Number(`${keyOfClinic}${idxChild}`)
                  return {
                    key: keyChild,
                    index: idxChild + 1,
                    clinic: clinic.clinicName,
                    ...dataOfClinic,
                  }
                }),
              }
            }),
          } as IDataReport01Monthly

          const dataOfService = convertGeneralReport01Value(service, 'normal')

          dataTotalOfTable = sumDataReport01(dataTotalOfTable, dataOfService)
          dataTable = dataTable.concat([
            saveData,
            {
              key: randomMoney(),
              service: 'Tổng',
              isTotalGroupTable: true,
              ...dataOfService,
            },
          ])
        })
        const lastData = dataTable.concat([
          {
            key: randomMoney(),
            service: 'Tổng tháng',
            isTotalGroupTable: true,
            isTotalTable: true,
            ...dataTotalOfTable,
          },
        ])

        return {
          ...initData,
          data: lastData,
        }
      }
      return initData
    } catch (error) {
      return initData
    }
  }

  const {
    tableData,
    expandedRowKeys,
    handleExpand,
    handleTableChange,
    handleResetExpand,
    fetch,
    fetchLoading,
  } = useBaseTableReportHook({
    getTreeTableData: getDataMonthly,
    isExpandedWhenStart: true,
  })

  const { columns, data, exportExcel } = useCommonHook({
    expandedRowKeys,
    typeHook: 'month',
    handleExpand,
    tableData,
    fetchLoading,
    currentFilter: props,
  })

  return {
    columns,
    tableData,
    handleTableChange,
    handleExpand,
    expandedRowKeys,
    handleResetExpand,
    fetch,
    fetchLoading,
    data,
    exportExcel,
  }
}
